module.exports = __webpack_public_path__ + "img/jsapipay.ca6f4c1d.png";